/**
 * en-GB messages added by shared reception task S-SR1 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const sSr1EnGB = {
    // Building area menu (a key ending in ".admin" is shown to building administrators only)
    'nav.section.building': 'Building',
    'sr.nav.building.companies': 'Companies',
    'sr.nav.building.evacuation': 'Evacuation',
    'sr.nav.building.history': 'History',
    'sr.nav.building.settings': 'Settings',
    'sr.nav.building.devices': 'Shared tablets',
    'sr.nav.building.phones': 'Marshal phones',
    // The name of a company's link on its devices page
    'sr.link.name': '{building} reception (shared)',
    // Invitation email to an organisation's administrators
    'email.shared-reception.invited.subject': '{building} has invited {tenant} to its shared reception',
    'email.shared-reception.invited.body': '{operator} has invited {tenant} to join the shared reception at {building}, {address}. One reception kiosk is used by several companies; each company keeps its own visitor records. Read what is shared and accept or decline in CloudSign.',
    'email.shared-reception.invited.button': 'See the invitation',
    // Shared tablet fault emails to the building's alert address
    'email.shared-reception.alert.subject': 'Problem with the shared kiosk at {building}',
    'email.shared-reception.alert.body': 'The shared kiosk "{device}" at {building} has a problem: {problem}. Since {since}.',
    'email.shared-reception.alert.button': 'Open the building area',
    'email.shared-reception.alert_cleared.subject': 'Shared kiosk at {building} is back to normal',
    'email.shared-reception.alert_cleared.body': 'The problem "{problem}" on the shared kiosk "{device}" at {building} has cleared. It began {since}.',
    'email.shared-reception.alert_cleared.button': 'Open the building area',
    'sr.alert.name.offline': 'Kiosk offline',
    'sr.alert.name.battery_low': 'Battery low',
    'sr.alert.name.printer_fault': 'Printer problem',
    'sr.alert.name.app_outdated': 'App out of date',
    'sr.alert.problem.offline': 'the kiosk has not been heard from for {minutes} minutes',
    'sr.alert.problem.battery_low': 'the battery is at {batteryPercent}%',
    'sr.alert.problem.printer_fault': 'the badge printer reports a fault ({state})',
    'sr.alert.problem.app_outdated': 'the kiosk app is out of date',
};
//# sourceMappingURL=s-sr1.js.map